import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentMode: 'standard',
};

const appModeSlice = createSlice({
  name: 'appMode',
  initialState,
  reducers: {
    setCurrentMode: (state, action) => {
      state.currentMode = action.payload;
    },
  },
});

export const { setCurrentMode } = appModeSlice.actions;

export default appModeSlice.reducer;
